export const footer = {
  switchToEnglish: {
    'en-US': `Switch to 🇬🇧/🇺🇸 `,
    'de-DE': `Switch to 🇬🇧/🇺🇸 `,
  },
  switchToGerman: {
    'en-US': `Auf 🇩🇪 wechseln`,
    'de-DE': `Auf 🇩🇪 wechseln`,
  },
  imprint: {
    'en-US': `Imprint`,
    'de-DE': `Impressum`,
  },
  madeWith: {
    'en-US': <>Made with ♥️ &nbsp;on&nbsp; 🌍</>,
    'de-DE': <>Mit&nbsp; ♥️ &nbsp;auf der&nbsp; 🌍 &nbsp;gemacht.</>,
  },
};

export const common = {
  joinBeta: {
    'en-US': `Test Beta`,
    'de-DE': `Beta testen`,
  },
};

export const hero = {
  title: {
    'en-US': `Would you fight Climate Change with any of these actions?`,
    'de-DE': `Würdest du so etwas gegen den Klimawandel tun?`,
  },
  findOutMore: {
    'en-US': `Find out more`,
    'de-DE': `Mehr herausfinden`,
  },
  energy: {
    a: {
      'en-US': `Switching to`,
      'de-DE': `Wechsel auf`,
    },
    b: {
      'en-US': `Renewable energy`,
      'de-DE': `Erneuerbare Energie`,
    },
  },
  car: {
    a: {
      'en-US': `Stoping`,
      'de-DE': `Kein`,
    },
    b: {
      'en-US': `driving`,
      'de-DE': `Auto mehr fahren`,
    },
  },
  food: {
    a: {
      'en-US': `Going`,
      'de-DE': `Vegan`,
    },
    b: {
      'en-US': `Vegan`,
      'de-DE': `ernähren`,
    },
  },
  fly: {
    a: {
      'en-US': `Flying`,
      'de-DE': `Weniger`,
    },
    b: {
      'en-US': `less`,
      'de-DE': `Fliegen`,
    },
  },
  civicEngagement: {
    a: {
      'en-US': `Civic`,
      'de-DE': `Bürgerliches`,
    },
    b: {
      'en-US': `engagement`,
      'de-DE': `Engagement`,
    },
  },
};

export const rule = {
  headline: {
    'en-US': (
      <>
        Every movement with ongoing participation of{' '}
        <span className="text-8xl">3.5%</span> of the population ensured serious
        political change.
      </>
    ),
    'de-DE': (
      <>
        Jede Bewegung mit dauerhafter Beteiligung von{' '}
        <span className="text-8xl">3.5%</span> der Bevölkerung hat grundlegenden
        politischen Wandel erreicht.
      </>
    ),
  },
};

export const comparison = {
  emissions: {
    'en-US': 'Emissions',
    'de-DE': 'Emissionen',
  },
  personal: {
    'en-US':
      'If you and all US & European citizens (1B people) stoped driving, went vegan, switched to green electricity, and flied 50% less, global emissions would go down by 10%.',
    'de-DE':
      'Wenn du und alle US-Amerikaner und Europäer kein Auto mehr fahren, Vegan werden, auf grüne Elektrizität wechseln und 50% weniger fliegen, verringern wir die globalen Emissionen um 10%.',
  },
  political: {
    'en-US':
      "Systemic change was always driven by people speaking up. When you and 3.5% of the population do something small and visible every week, we'll stop the climate crisis.",
    'de-DE':
      'Systemischer Wandel entstand immer durch Menschen, die sich eingemischt haben. Wenn du und 3.5% der Bevölkerung jede Woche etwas kleines, sichtbares tun, stoppen wir die Klimakrise.',
  },
};

export const oneBillionQuestion = {
  headline: {
    'en-US': 'How can you fight climate change, 1h/week?',
    'de-DE': 'Wie kannst du in einer Stunde/Woche den Klimawandel bekämpfen?',
  },
  lobbying: {
    'en-US': 'Engage politicians every week with climate facts.',
    'de-DE': 'Sprich wöchentlich mit Politiker*innen über Klimafakten.',
  },
  brands: {
    'en-US':
      'Tell top followers of greenwashing brands about better alternatives.',
    'de-DE':
      'Erzähl den Top-Followern von Marken mit Greenwashing von besseren Alternativen.',
  },
  earth: {
    'en-US':
      'Amplify the voices of people affected by environmental destruction.',
    'de-DE':
      'Verstärke die Stimmen derer, die am meisten von Umweltzerstörung betroffen sind.',
  },
  companies: {
    'en-US': 'Help companies decarbonise with guides and best practices.',
    'de-DE':
      'Hilf Firmen mit Beispielen und Erfolgsgeschichten, grüner zu werden.',
  },
  learn: {
    'en-US': 'Learn from inspiring and insightful reads and videos.',
    'de-DE': 'Lerne aus inspirierenden und informativen Artikeln und Videos.',
  },
  more: {
    'en-US':
      "Together with scientists and organizers we're preparing more exciting actions in store.",
    'de-DE':
      'Zusammen mit Wissenschaftler*innen und Engagierten bereiten wir mehr aufregende Aktionen vor.',
  },
};

export const beta = {
  whoIfNotYou: {
    'en-US': (
      <>
        Who if not <span style={{ fontFamily: 'Nimbus Sans Bold' }}>you</span>?
      </>
    ),
    'de-DE': (
      <>
        Wer, wenn nicht{' '}
        <span style={{ fontFamily: 'Nimbus Sans Bold' }}>du</span>?
      </>
    ),
  },
  whenIfNotNow: {
    'en-US': (
      <>
        When if not <span style={{ fontFamily: 'Nimbus Sans Bold' }}>now</span>?
      </>
    ),
    'de-DE': (
      <>
        Wann, wenn nicht{' '}
        <span style={{ fontFamily: 'Nimbus Sans Bold' }}>jetzt</span>?
      </>
    ),
  },
  description: {
    'en-US':
      'Together we find the most engaging and impactful activities. Your daily dose of civic engagement.',
    'de-DE':
      'Zusammen finden wir die stärksten und motivierendsten Aktivitäten. Deine tägliche Dosis Bürgerbeteiligung.',
  },
  testimonialA: {
    'en-US':
      'I don’t think I ever had that feeling of having influence before.',
    'de-DE':
      'Ich weiß nicht, wann ich schon einmal so sehr gefühlt habe, Einfluss zu haben.',
  },
  testimonialB: {
    'en-US': (
      <>
        Flipping the tiles before breakfast.
        <br />I love it!
      </>
    ),
    'de-DE': (
      <>
        Vor dem Frühstück Kacheln flippen.
        <br />
        Ich liebe es!
      </>
    ),
  },
  ctaBoxText: {
    'en-US': (
      <>
        Ready for a wild ride? <br />
        Play around with our beta version and tell us what you think!
      </>
    ),
    'de-DE': (
      <>
        Bereit für einen wilden Ritt? <br />
        Erkunde unsere Beta-Version und erzähl uns, was du denkst!
      </>
    ),
  },
  ctaBoxLink: {
    'en-US': <>Test 🇩🇪 &nbsp;Beta</>,
    'de-DE': <>Beta testen</>,
  },
};
